export default class lowlayerManager {
    constructor(effect) {

        this.effect = effect;

        this.status = {
        }

    }
    init(execution,pageID){


        if(execution=="landing"){
        }else{
        }

    }
    show(){// 画面遷移時に使用
    }
    out(){// 画面遷移時に使用
    }
    render(mouse,scrollInc){

    }
    resize(displayType){
    }
}